import { URLASSOLUTO } from "./variables";
import axios from "axios";

document.addEventListener("DOMContentLoaded", function () {
  // condividi via email corso
  const condividiEmail = document.querySelector("#condividiEmail");
  if (condividiEmail) {
    condividiEmail.addEventListener("click", async (e) => {
      const courseUrl = condividiEmail.getAttribute("course-url");
      const response = await axios.get(
        `${URLASSOLUTO}/share-email/${courseUrl}`
      );

      const obj = response.data;

      const subject = `Corso: ${obj.corso}`;
      const body = `Area: ${obj.area}%0D%0ASpecializzazione: ${obj.specializzazione}%0D%0ACorso: ${obj.corso}%0D%0A%0D%0ACorso consultabile tramite il seguente link: ${URLASSOLUTO}${obj.url}`;

      window.location.href = `mailto:?subject=${subject}&body=${body}`;
    });
  }

  // stampa corso
  const stampaCorso = document.querySelector("#stampaCorso");
  if (stampaCorso) {
    stampaCorso.addEventListener("click", (e) => {
      const courseUrl = stampaCorso.getAttribute("course-url");
      const url = `${URLASSOLUTO}/print-course/${courseUrl}.html`;
      const urlPdf = `https://phantompdf.area-ftp.com/?url=${url}`;
      //console.log(urlPdf);

      window.open(urlPdf, "_blank");
    });
  }
});
